<template>
  <div
    v-if="reportHasNotifications"
    class="text-center"
  >
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      offset-x
      open-on-hover
    >
      <template #activator="{on, attrs}">
        <v-btn
          color="indigo"
          icon
          v-bind="attrs"
          v-on="on"
        >
          <v-badge
            :content="reportNotificationsCount"
            color="info darken-1"
            light
            overlap
          >
            <v-icon color="info">
              mdi-email
            </v-icon>
          </v-badge>
        </v-btn>
      </template>

      <v-card>
        <v-simple-table
          class=""
          dense
        >
          <thead>
            <tr>
              <th class="text-center text-no-wrap">
                {{ $t('Order.OrderDetailsDialog.ReceiptNotify.User') }}
              </th>

              <th class="text-center text-no-wrap">
                {{ $t('Order.OrderDetailsDialog.ReceiptNotify.Email') }}
              </th>

              <th
                class="text-center text-no-wrap"
              >
                {{ $t('Order.OrderDetailsDialog.ReceiptNotify.CreatedAt') }}
              </th>

              <th
                class="text-center text-no-wrap"
              >
                {{ $t('Order.OrderDetailsDialog.ReceiptNotify.DeliveredAt') }}
              </th>

              <th
                class="text-center text-no-wrap"
              >
                {{ $t('Order.OrderDetailsDialog.ReceiptNotify.ReadAt') }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="(item, itemIdx) in reportNotifications"
              :key="`receipt-${item.ReceiptId}-notification-${item.Id}-${itemIdx}`"
            >
              <td class="text-caption text-center text-no-wrap">
                <user-chip
                  v-if="item.StaffId > 0"
                  :color="item.UserColor"
                  :full-name="item.User"
                  :short-name="item.UserShortName"
                />
              </td>

              <td class="text-caption text-no-wrap">
                {{ item.Email }}
              </td>

              <td
                class="text-caption text-no-wrap text-center"
              >
                {{ item.CreatedAt }}
              </td>

              <td
                class="text-center"
              >
                <v-tooltip
                  v-if="item.DeliveredAt"
                  color="success"
                  left
                >
                  <template #activator="{on}">
                    <v-icon
                      color="success"
                      v-on="on"
                    >
                      mdi-email-check
                    </v-icon>
                  </template>

                  {{ item.DeliveredAt }}
                </v-tooltip>

                <v-tooltip
                  v-if="item.BouncedAt"
                  color="error"
                  left
                >
                  <template #activator="{on}">
                    <v-icon
                      color="error"
                      v-on="on"
                    >
                      mdi-email-remove
                    </v-icon>
                  </template>

                  <div style="max-width: 200px">
                    <div>{{ item.BouncedAt }}</div>
                    <div class="text-caption mt-2">
                      {{ item.BounceMessage }}
                    </div>
                  </div>
                </v-tooltip>
              </td>

              <td
                class="text-center"
              >
                <v-tooltip
                  v-if="item.ReadAt"
                  color="teal"
                  left
                >
                  <template #activator="{on}">
                    <v-icon
                      color="teal"
                      v-on="on"
                    >
                      mdi-email-newsletter
                    </v-icon>
                  </template>

                  {{ item.ReadAt }}
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>
    </v-menu>
  </div>
</template>

<script>

import {getContrastColor} from '@/lib/color/index.js'
import UserChip from '@/components/common/UserChip.vue'

export default {
  name      : 'ReportsNotifyDetails',
  components: {UserChip},
  directives: {},
  mixins    : [],
  props     : {
    report: {
      type   : Object,
      default: undefined
    }
  },
  data() {
    return {
      menu: false
    }
  },
  computed: {
    reportNotifications() {
      return this.report?.Related || []
    },

    reportNotificationsCount() {
      return this.reportNotifications.length
    },

    reportHasNotifications() {
      return this.reportNotificationsCount > 0
    },


    reportHasCreatedNotifications() {
      return this.reportNotifications.some(notification => !!notification.CreatedAt)
    },
    reportHasDeliveredNotifications() {
      return this.reportNotifications.some(notification => !!notification.DeliveredAt)
    },
    reportHasReadNotifications() {
      return this.reportNotifications.some(notification => !!notification.ReadAt)
    },
    reportHasBouncedNotifications() {
      return this.reportNotifications.some(notification => !!notification.BouncedAt)
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    getContrastColor
  }
}
</script>

<style scoped>

</style>
